enum FeatureToggle {
    SIDEPANEL_WIDTH_TOGGLE = "qm.ui.wem374",
    REPORTING_TOGGLE = "qm.release.evaluation.reporting",
    ADMIN_UI_DECOMPOSITION = "qm.adminUIDecomp",
    SYSTEM_MARKED_NA_FEATURE_TOGGLE_NAME = "qm.release.markedNAHiddenFlag",
    REVISION_CREATED_DATE_TOGGLE = "qm.17026.revision.created.date",
    EVALUATION_OVERVIEW_DEPRECATION = "WEM-1242_Evaluation-Dashboard-Deprecation",
    MULTIPLE_SELECT = "WEM-1107_MULTIPLE-SELECT",
    NEW_RESOURCE_CENTER_URI = "PURE-6363_new_resource_center_URI",
    AUTOMATED_EVALUATION_COMPLETION = "QM-18908_Automated_Evaluation_Completion",
    EVALUATION_FORM_DEFAULT_ANSWERING = "WEM-1359_EVALUATION_FORM_DEFAULT_ANSWERING",
    QM_RELEASE_EVALUATION_REPORTING_CUSTOMER = "WEM-556_QM_RELEASE_EVALUATION_REPORTING_CUSTOMER",
    INTERNATIONALIZATION_DATE_TIME = "PURE-2946_InternationalizationOfDatesAndTimes",
    USE_OUTER_LIMITS = "WEM-1468_USE_OUTER_LIMITS",
    DIVISION_AWARE_EVALS_SURVEYS = "WEM-1090_DIVISION_EVALS_SURVEYS",
    AI_SCORING_LIMIT_INCREASE_FOR_ANSWER_OPTIONS = "WEM-1532_AI_Scoring_Limit_Increase_For_Answer_Options",
    WEM_1511_EVALUATION_FOCUS = "WEM-1511_Evaluation_Focus",
    DRAFT_FORM_AGREEMENT_RATE = "WEM-1579_Agreement_Rate_Evaluation_Form_Editor",
    VOICE_SURVEY_FREE_TEXT_CHAR_LIMIT_INCREASE = "WEM-1565_Voice_Survey_Free_Text_Char_Limit_Increase",
    MAX_AI_SCORING_QUESTION_OUTER_LIMIT = "WEM-1599_question_limit_increase",
    EVALUATION_FORM_LIVE_UPDATES = "WEM-1598_evaluation_form_agent",
    QM_22699_EVAL_SURVEY_UI_IMPROVEMENT = "QM-22699_Eval_Survey_UI_Improvement",
}
export default FeatureToggle;
